































































import { Component, Prop, Vue } from "vue-property-decorator";
import {
  ReferralDetailsModel,
  RelatedReferralModel,
} from "@/types/aznconnect_api";

import DetailPaneRelatedReferrals from "@/components/DetailPaneRelatedReferrals.vue";
import PatientInformationView from "@/components/triage/PatientInformationView.vue";
import ProfessionalSummaryDetailPane from "@/components/professionalsummary/DetailPane.vue";

@Component({
  components: {
    "detail-pane-related-referrals": DetailPaneRelatedReferrals,
    "patient-information-view": PatientInformationView,
    "professional-summary-detail-pane": ProfessionalSummaryDetailPane,
  },
})
export default class SelfReferrerDetailPane extends Vue {
  @Prop({ default: null })
  referral!: ReferralDetailsModel;

  @Prop({ default: null })
  relatedReferrals!: RelatedReferralModel[];

  @Prop({ default: null })
  referralState!: string;

  @Prop({ default: false })
  isReadOnly!: boolean;

  @Prop({ default: false })
  allowLinkPatientNumber!: boolean;

  @Prop({ default: false })
  allowSetReferralState!: boolean;

  @Prop({ default: false })
  allowProfessionalSummary!: boolean;

  @Prop({ default: true })
  allowPageClose!: boolean;

  @Prop({ default: "" })
  patientNumber!: string;

  psMode: boolean = true;
  failedToLoad: boolean = false;

  copyLinkToClipboard(): void {
    const route = this.$router.resolve({
      name: "referral-details",
      params: { referralId: this.referral.Reference || "" },
    });
    const url = window.location.origin + "/" + route.href;

    var temp = $("<input>");
    $("body").append(temp);
    temp.val(url).select();
    try {
      var successful = document.execCommand("copy");
      var msg = successful ? "successful" : "unsuccessful";
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    }
    temp.remove();
  }

  closeDetails(): void {
    this.$emit("close");
  }

  mounted() {
    this.$emit("opened");
  }

  destroyed() {
    this.$emit("closed");
  }
}
